import { createActionGroup, props } from '@ngrx/store';
import { ResolvedCategoryConfigurationDto } from '@rocksoft/settings-sdk';
import { ErrorModel } from '@rocksoft/shared';

export const CategoryResolvedConfigurationResolverActions = createActionGroup({
  source: 'Category resolved configuration resolver',
  events: {
    'Category resolved configuration requested': props<{ categoryId: string }>(),
  },
});

export const CategoryResolvedConfigurationApiActions = createActionGroup({
  source: 'Category resolved configuration API',
  events: {
    'Category resolved configuration loaded': props<{ configuration: ResolvedCategoryConfigurationDto }>(),
    'Category resolved configuration loaded error': props<{ error: ErrorModel }>(),
  },
});
